import { AppProgressLine } from '../../../../../component/common/analog/molecule/loader/AppProgressLine'
import { AppContainer } from '../../../../../component/common/analog/molecule/AppContainer'
import { HeaderProps } from '../../../model/HeaderProps'
import { ChildrenProps } from '../../../../../model/React'
import { useMainStore } from '../../../../../store/main.store'
import { AppAnalogBar } from '../../analog/AppAnalogBar'
import { observer } from 'mobx-react-lite'
import { NodeId } from '../../../../../util/node-id'
import { SxHelperStyle } from '../../../../theme/style/styleUtilities'
import { Theme } from '@mui/material'
import { AppIconButton } from 'src/component/common/analog/molecule/button/AppIconButton'
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'

type Props = HeaderProps & ChildrenProps

export const BaseAppHeaderBar = observer((props: Props) => {
  const mainStore = useMainStore()

  const { children, onToggleDrawer, isDrawerOpen } = props
  const isLoading = mainStore.isGlobalLoader && mainStore.isLoading

  return (
    <AppAnalogBar
      sx={styles.root}
      id={NodeId.HEADER}
    >
      <AppProgressLine isShowing={isLoading} sx={styles.loading} />

      <AppContainer sx={styles.container}>
        {onToggleDrawer && (
          <AppIconButton sx={styles.toggleButton} onClick={onToggleDrawer}>
            {isDrawerOpen
              ? <MenuOpenRoundedIcon sx={styles.toggleIcon} />
              : <MenuRoundedIcon sx={styles.toggleIcon} />}
          </AppIconButton>
        )}
        {children}
      </AppContainer>
    </AppAnalogBar>
  )
})

const styles = {
  root: (theme: Theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    height: theme.spacing(55),
    border: 'none',
    borderBottom: 'none',
    borderRadius: 0,
  }),
  loading: {
    position: 'absolute',
    top: 0,
    margin: 0,
    borderRadius: '10px',
  },
  container: {
    ...SxHelperStyle.flexCenterX,
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin: '0 auto',
    padding: '0 1.5em !important',
    maxWidth: 'unset',
  },
  toggleButton: {
    display: {
      xs: 'none',
      md: 'inline-flex',
    },
    p: 0,
    minWidth: 30,
    minHeight: 30,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  toggleIcon: {
    color: 'text.primary',
    transition: 'transform 0.3s ease',
    height: 22,
    width: 22,
  },
}
